import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  public static stripeUrl="https://api.stripe.com/v1/";
  public static serverURL = environment.apiUrl; // demo 
  // public static serverURL =  'https://univate.ie/portal/api/'; // demo 
  public static imageURL = 'https://univate.ie/portal/api/'; // portal live
  // public static imageURL = 'https://univate.ie/new_demo2/api/'; // new demo live

  // public static imageURL = 'https://univate.ie/demo/api/'; // demo live
  // public static pageSizeOptions =  [10, 15, 30];
  public static pageSizeOptions =  [12,20, 40];
  public static maxPaginationSize=5; 
  public static searchTimeOut=2000;
  // stripe keys
  // here secret key is used to set Authorization token
  // public static stripePublishKey = 'pk_test_51JXXFeG5VqJP3zTP4Qmmr1bKcErfFlJ2XwMmNKHsEGLbhj7wVj1p69343kIbLcqyow0bSKhSGs1gJoFaygtK1hgp00uQGHwsxq'; // test
  // public static stripeSecretKey = 'sk_test_51JXXFeG5VqJP3zTPrpTRUHMMmo7XGQQtBNUnkTm5nQAauLvz1rpLFxaUe8DBVWn8z05SlCZEUTayVbQaOa12toZ700vsudBhm6'; // test

  public static  stripePublishKey = 'pk_live_51JXXFeG5VqJP3zTPbY3Py8hASMFtVm4gT1iXlf2T9Kgdku2tss1M3UofZW0MK08SpgSLO2o0vbSPMbzlwSoLIcqF00iP3Qtlh7'; // live 
  public static  stripeSecretKey = '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'; // live

  public static userType:string="ADMIN";
  constructor() { }
}
